import 'dayjs/locale/ru';

export default {
  actionSheet: {
    cancel: 'Отмена',
  },
  calendar: {
    confirm: 'Подтвердить',
    title: 'Выберите дату',
    weekdays: ['Вс', 'Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб'],
    monthTitle: '{month} {year}',
    months: [
      'Январь',
      'Февраль',
      'Март',
      'Апрель',
      'Май',
      'Июнь',
      'Июль',
      'Август',
      'Сентябрь',
      'Октябрь',
      'Ноябрь',
      'Декабрь',
    ],
  },
  cascader: {
    title: 'Название',
    placeholder: 'Выберите опцию',
  },
  dropdownMenu: {
    reset: 'Сброс',
    confirm: 'Подтвердить',
  },
  dateTimePicker: {
    title: 'Выберите время',
    cancel: 'Отмена',
    confirm: 'Подтвердить',
    format: 'DD.MM.YYYY',
    yearLabel: 'Год',
    monthLabel: 'Месяц',
    dateLabel: 'День',
    hourLabel: 'Час',
    minuteLabel: 'Минута',
    secondLabel: 'Секунда',
  },
  picker: {
    cancel: 'Отмена',
    confirm: 'Подтвердить',
  },
  pullDownRefresh: {
    loadingTexts: ['Потяните вниз для обновления', 'Отпустите для обновления', 'Обновление...', 'Обновление завершено'],
  },
  rate: {
    valueText: '{value} баллов',
    noValueText: 'Без оценки',
  },
  tabBar: {
    newsAriaLabel: 'Есть новые сообщения',
    moreNewsAriaLabel: 'Есть много новых сообщений',
    haveMoreNewsAriaLabel: 'Есть {value}+ сообщений',
    haveNewsAriaLabel: 'Есть {value} сообщений',
  },
  table: {
    empty: 'Нет данных',
  },
  list: {
    loading: 'Загрузка...',
    loadingMoreText: 'Нажмите, чтобы загрузить больше',
    pulling: 'Потяните, чтобы обновить...',
    loosing: 'Отпустите, чтобы обновить...',
    success: 'Успешно обновлено',
  },
  upload: {
    progress: {
      uploadingText: 'Загрузка...',
      waitingText: 'Ожидание загрузки',
      failText: 'Ошибка загрузки',
      successText: 'Загрузка завершена',
    },
  },
  guide: {
    next: 'Далее',
    skip: 'Пропустить',
    finish: 'Готово',
    back: 'Назад',
  },
  qrcode: {
    expiredText: 'истекший',
    refreshText: 'обновить',
    scannedText: 'сканированный',
  },
};
